import * as React from 'react'
import styles from './footerLinkList-style.css'
import type { FooterLinkListViewModel } from '../../view-models/FooterLinkListViewModel'
import Paragraph from '../Paragraph/Paragraph'
import Link from '../Link/Link'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
type Props = {
  lists?: Array<FooterLinkListViewModel>
  heading?: string
}

function FooterLinkList({ lists }: Props) {
  function getEventMeta(link: LinkViewModel) {
    return {
      event: 'footer-click',
      eventData: link.label,
    }
  }

  return (
    <div className={styles.footerLinkList}>
      {lists &&
        lists.map((list, index) =>
          list ? (
            <div key={`${index}-${list.header}`} className={styles.listWrapper}>
              <Paragraph
                className={styles.listHeader}
                marginBottom={'none'}
                size={'xsmall'}
                weight={'regular'}
                tag={'span'}
              >
                {list.header}
              </Paragraph>
              <ul key={`${index}-list`} className={styles.linksWrapper}>
                {list.links.map((link) =>
                  link ? (
                    <li key={link.label} className={styles.linkItem}>
                      <Link className={styles.link} {...link} eventMeta={getEventMeta(link)}>
                        {link.label}
                      </Link>
                    </li>
                  ) : null,
                )}
              </ul>
            </div>
          ) : null,
        )}
    </div>
  )
}

FooterLinkList.displayName = 'FooterLinkList'
FooterLinkList.defaultProps = {}
export default FooterLinkList